import {
  Sun, Moon, Sparkles, Shirt, UtensilsCrossed, Bath, BedDouble, BookOpen,
  Heart, Smile, Frown, Angry, GlassWater, Apple, Pizza, CupSoda, Cookie,
  Milk, Sandwich, Music, Tv, Puzzle, TreePine, ShoppingCart, Car, School,
  Toilet, ThumbsUp, HelpCircle, Home, Star, Dog, Cat, Gamepad2, Pencil,
  Clock, Phone, Users, Pill, Bike, Bus, Umbrella, Backpack, Brush,
  Droplets, ShowerHead, Hand, Megaphone, Pause, Play, Check, Footprints,
  Baby, Coffee, Salad, Flower2, Ghost, CloudRain, HeartHandshake,
  ListChecks, LayoutGrid, Waves, ClipboardList, Sofa, Dumbbell, Paintbrush,
  IceCreamCone, Clapperboard, Popcorn, Ticket, Church, Stethoscope, Trophy,
  Volleyball, Medal, Bandage, Thermometer, Snowflake, VolumeX, Plus,
  CircleStop, GraduationCap, Ear, Eye, Armchair, ArrowUp, ArrowDown,
} from "lucide-react";

export const ICONS = {
  Sun, Moon, Sparkles, Shirt, UtensilsCrossed, Bath, BedDouble, BookOpen,
  Heart, Smile, Frown, Angry, GlassWater, Apple, Pizza, CupSoda, Cookie,
  Milk, Sandwich, Music, Tv, Puzzle, TreePine, ShoppingCart, Car, School,
  Toilet, ThumbsUp, HelpCircle, Home, Star, Dog, Cat, Gamepad2, Pencil,
  Clock, Phone, Users, Pill, Bike, Bus, Umbrella, Backpack, Brush,
  Droplets, ShowerHead, Hand, Megaphone, Pause, Play, Check, Footprints,
  Baby, Coffee, Salad, Flower2, Ghost, CloudRain, HeartHandshake,
  ListChecks, LayoutGrid, Waves, ClipboardList, Sofa, Dumbbell, Paintbrush,
  IceCreamCone, Clapperboard, Popcorn, Ticket, Church, Stethoscope, Trophy,
  Volleyball, Medal, Bandage, Thermometer, Snowflake, VolumeX, Plus,
  CircleStop, GraduationCap, Ear, Eye, Armchair, ArrowUp, ArrowDown,
};

export const ICON_NAMES = Object.keys(ICONS);

export function IconRenderer({ name, size = 32, strokeWidth = 2.5, className = "" }) {
  const Cmp = ICONS[name] || Star;
  return <Cmp size={size} strokeWidth={strokeWidth} className={className} aria-hidden="true" />;
}
